import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '@/components/layout/AppLayout'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: '/reborndemo',
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: [
        {
          path: '/',
          name: 'PageIndex',
          component: () => import('@/pages/Index')
        },
        {
          path: '/about-us',
          name: 'AboutUs',
          component: () => import('@/pages/aboutUs/Index')
        },
        {
          path: '/school-class',
          name: 'SchoolClass',
          component: () => import('@/pages/schoolClass/Index')
        },
        {
          path: '/reborn-workshop',
          name: 'RebornWorkshop',
          component: () => import('@/pages/rebornWorkshop/Index')
        },
        {
          path: '/question-answer',
          name: 'QuestionAnswer',
          component: () => import('@/pages/questionAnswer/Index')
        },
        {
          path: '/private-policy',
          name: 'PrivatePolicy',
          component: () => import('@/pages/privatePolicy/Index')
        },
        {
          path: '/user-term',
          name: 'UserTerm',
          component: () => import('@/pages/userTerm/Index')
        },
        {
          path: '/account-coupon',
          name: 'AccountCoupon',
          component: () => import('@/pages/accountCoupon/Index')
        },
        {
          path: '*',
          name: '404',
          component: () => import('@/pages/Index')
        }
      ]
    }
  ],
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js